import { PlotDispatchTypes, PLOT_LOADING, PLOT_SUCCESS, PLOT_FAIL, PLOT_EDIT } from "../actions/plotActionTypes";


interface DefaultStateI {

    loading?: boolean,
    plotInfo?: any,
    msg?: string,
    plotEdit?:any

}


const defaultState: DefaultStateI = {

    loading: false,
    // customerInfo: [ ],
    msg: '',
    plotEdit: [ ]

}


const plotReducer = ( state: DefaultStateI = defaultState, action: PlotDispatchTypes ): DefaultStateI => {

    switch( action.type ) {

        case PLOT_FAIL:
            return {
                ...state,
                loading: false,
                plotInfo: [ ],
                msg: action.payload
                
            }
        case PLOT_LOADING:
            return {
                loading: true
            }
        case PLOT_SUCCESS:
            return {
                loading: false,
                plotInfo: action.payload

            }
            
        case PLOT_EDIT:
            console.log( 'inr eduer ', action.payload );
            return {
                ...state,
                plotEdit: action.payload
            }
        default:
            return state

    }
}

export default plotReducer;